import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import { useUiStatus } from '@/hooks/useUiStatus';
import DetailTitle from '@/components/ideas/DetailTitle';
import useUser from '@/hooks/useUser';
import { favoritePost } from '@/domains/firestore/user';
import { IIdea } from '@/@types/generated/contentful';

type ComponentProps = {
  idea: IIdea;
};

const DetailTitleContainer: React.FC<ComponentProps> = ({ idea }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { setModalState } = useUiStatus();
  const user = useUser();
  const isFavorite = !!user?.favorited?.includes(idea.fields.id);
  const handleRequestUpdateFavorite = useCallback(
    async (postId) => {
      if (!user) {
        setModalState(true);
      } else {
        setLoading(true);
        await favoritePost({ userId: user.uid, postId });
        await dispatch(updateUser(user.uid));
        setLoading(false);
      }
    },
    [dispatch, setModalState, user]
  );
  return (
    <DetailTitle
      idea={idea}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      isFavorite={isFavorite}
      invalid={isLoading}
    />
  );
};

export default DetailTitleContainer;
